import React from 'react';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { TableColumnInterface } from 'components/Table/table.types';
import OverviewTable from 'components/Table/Table';
import { IconBox } from 'components/StyledComponents/IconBox';
import { useBrandsContext } from './brands.context';
import CreateBrand from './CreateBrand';
import { Brand } from '@restore/services-lib';
import UpdateBrand from './UpdateBrand';
import ArchiveBrand from './ArchiveBrand';

const BrandsTable = (): JSX.Element => {
  const { brands } = useBrandsContext();

  const tableCols: TableColumnInterface<Brand>[] = [
    { label: 'ID', value: (brand) => brand.id },
    {
      label: 'Name',
      value: (brand) => brand.name,
      sortBy: 'name',
    },
    {
      label: '',
      align: 'right',
      value: (brand) => (
        <IconBox>
          <UpdateBrand brand={brand} />
          <ArchiveBrand brand={brand} />
        </IconBox>
      ),
    },
  ];

  return (
    <OverviewTable
      data={brands.filter((brand) => !brand.archived)} // TODO HR20-285:  add filters to brands
      columns={tableCols}
      tableTitle='Brands'
      tableActions={<CreateBrand />}
      noDataMessageOverride={<EmptyData dataType='brand' action={<CreateBrand />} />}
    />
  );
};

export default BrandsTable;
